import React from 'react';
import type {BoxProps} from '@tempo/core';
import {VStack} from '@tempo/core';

type FormSectionProps = BoxProps;

const FormSection = ({children, ...props}: FormSectionProps) => {
	return (
		<VStack spacing="spacing.l" alignItems="initial" {...props}>
			{children}
		</VStack>
	);
};

export default FormSection;
